export const routes = {
  landingPage: '/money',
  homepage: '/credit-line',
  personalDetails: '/credit-line/personal-details',
  addressDetails: '/credit-line/address-details',
  professionalDetails: '/credit-line/professional-details',
  creditLimit: '/credit-line/credit-limit',
  bankDetails: '/credit-line/bank-details',
  checkMandateStatus: '/credit-line/check-mandate-status',
  loanAgreement: '/credit-line/loan-agreement',
  creditStatus: '/credit-line/credit-status',
  emiSelection: '/credit-line/emi-selection',
  selectLoanAmount: '/credit-line/select-loan-amount',
  selfieKyc: '/credit-line/selfie-kyc',
  vKyc: '/credit-line/v-kyc',
  vKycStatus: '/credit-line/v-kyc/status',
  pollingPage: '/credit-line/polling-page',
  pullSchedules: '/credit-line/pull-schedules',
};
